import { FinancialOverview } from '../../../shared/types';
import React, { createContext, useContext, useState } from 'react';

type ContextType<S> = [S, React.Dispatch<React.SetStateAction<S>>] | null;

const initialState = null;
const FinancialOverviewInfoContext = createContext<ContextType<FinancialOverview>>(null);
FinancialOverviewInfoContext.displayName = 'FinancialOverviewInfoContext';

function useCurrentFinancialOverview() {
    const context = useContext(FinancialOverviewInfoContext);
    if (!context) {
        throw new Error(`useCurrentFinancialOverview must be used within a FinancialOverviewInfoProvider`);
    }

    const [currentFinancialOverview, setCurrentFinancialOverview] = context;

    return {
        currentFinancialOverview,
        setCurrentFinancialOverview,
    };
}

function FinancialOverviewInfoProvider(props) {
    const trip = useState(initialState);
    return <FinancialOverviewInfoContext.Provider value={trip} {...props} />;
}

export { FinancialOverviewInfoProvider, useCurrentFinancialOverview };
